<div class="contact-info-container" [formGroup]="contactInfoForm">
    <p class="description-text">{{'MENU_EDIT_PREFERENCES_CONTACT_INFO_DESCRIPTION' | translate}}</p>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'COMPANY_NAME' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <mat-select formControlName="companyName">
                    @for (company of companyNames; track company.description) {
                        <mat-option [value]="company.description">
                            {{company.description}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'COUNTRY' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <mat-select formControlName="country">
                    @for (country of countries; track country.id) {
                        <mat-option [value]="country.id">
                            {{country.description}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_ADDRESS1' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="officeAddress1">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_ADDRESS2' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="officeAddress2">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_STATE' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput maxlength="25" formControlName="officeState">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_ZIP_CODE' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="officeZipCode">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_CONTACT' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput maxlength="35" formControlName="officeContact">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'OFFICE_EMAIL' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="officeEmail">
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'WEBSITE_ADDRESS' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="websiteAddress">
            </mat-form-field>
        </div>
    </div>
</div>
